import React, { useState } from 'react';
import wit from '../../../../assets/images/wit.svg'
import luis from '../../../../assets/images/logo-luis.svg'
import flow from '../../../../assets/images/logo-dialogflow.svg'
import watson from '../../../../assets/images/watson_icon2.png'
import boteria from '../../../../assets/images/logo-code7-boteria.svg'
import HelpBalloon from '../../component/HelpBalloon/HelpBalloon'

import './Provedores.scss';
import ConnectCreator from './connectCreator/ConnectCreator';
import { useEffect } from 'react';
import { Icon } from '@material-ui/core';

const Provedores = ({ platform, bot, getIaInfo }) => {
    const [config, setConfig] = useState(false)
    const [nameConfig, setNameConfig] = useState('')
    
    const isConfig = (name) => {
        const ia = bot && bot.ia && bot.ia.platforms.find(element => element.platform === name)
        if (ia) {
            getIaInfo(ia.token);
        }
        setConfig(!config)
        setNameConfig(name)
    }
    return (
        <div>
            {config === false &&
                <div className="container-provedor">
                    <p>
                        Provedores de Inteligência Artificial - Nativo
                        <HelpBalloon id="nativeProviders" message="Disponibilizamos para nossos usuários como provedor nativo o Wit."/>
                    </p>
                    <div className="container-provedor-all-cards">
                        <div className={`container-provedor-card ${platform === 'boteria' ? 'card-ativo' : ''}`}>
                            {platform === 'boteria' && <span className="ativo-provedor">ativo</span>}
                            <div className="tam-img-provedor">
                                <img src={boteria} style={{ marginTop: 45, width: 140 }} />
                            </div>
                            <div className="info-provedor-btn" >
                                <span>Boteria</span>
                                <button onClick={() => isConfig('boteria')}>Configurar</button>
                            </div>
                        </div>
                       
                    </div>
                    <p>
                        Provedores de Inteligência Artificial - Terceiros
                        <HelpBalloon id="thirdPartyProviders" message="Aqui você pode configurar seus próprios provedores de IA. Para saber como clique em configurar."/>
                    </p>
                    <div className="container-provedor-all-cards">
                    <div className={`container-provedor-card ${platform === 'wit' ? 'card-ativo' : ''}`}>
                            {platform === 'wit' && <span className="ativo-provedor">ativo</span>}
                            <div className="tam-img-provedor">
                                <img src={wit} style={{ marginTop: 45 }} />
                            </div>
                            <div className="info-provedor-btn" >
                                <span>Facebook wit</span>
                                <button onClick={() => isConfig('wit')}>Configurar</button>
                            </div>
                        </div>
                        <div className={`container-provedor-card ${platform === 'luis' ? 'card-ativo' : ''}`}>
                            {platform === 'luis' && <span className="ativo-provedor">ativo</span>}
                            <div className="tam-img-provedor">
                                <img src={luis} />
                            </div>
                            <div className="info-provedor-btn" >
                                <span>Microsoft Luis</span>
                                <button  onClick={() => isConfig('luis')}>Configurar</button>
                            </div>
                        </div>
                        {/* <div className="container-provedor-card o-watson" style={{ border: '1px solid #E9EBEE' }}>
                            <div className="tam-img-provedor">
                                <img src={watson} />
                            </div>
                            <div className="info-provedor-btn" >
                                <span>IBM Watson</span>
                                <button disabled style={{ backgroundColor: '#ffc76f' }}>Configurar</button>
                            </div>
                        </div>
                        <div className="container-provedor-card o-flow" style={{ border: '1px solid #E9EBEE' }}>
                            <div className="tam-img-provedor">
                                <img src={flow} />
                            </div>
                            <div className="info-provedor-btn" >
                                <span>Google Dialogflow</span>
                                <button disabled style={{ backgroundColor: '#ffc76f' }}>Configurar</button>
                            </div>
                        </div> */}
                    </div>
                </div>
            }
            {config === true &&
                <ConnectCreator name={nameConfig} setConfig={setConfig} />
            }
        </div>

    )
}

export default Provedores;